import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { BiError } from "react-icons/bi";

const NotFoundPage = () => {
  return (
    <>
      <SEO
        title="404 Page Not Found"
        description="The page you are looking for could not be found."
        url="https://ezcarrentals.com.au/404"
        robots="noindex, nofollow"
      />
      <div className='not-found-container'>
        <div className='not-found-content'>
          <BiError className='not-found-icon' />
          <h1>404 - Not Found</h1>
          <p>Sorry, the page you are looking for might be in another galaxy.</p>
          <Link to='/'>Go back to Home</Link>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
